import React, { useEffect, useState } from 'react'
import clsx from 'clsx'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import CircularProgress from 'karrierhub-ui/dist/common/src/svg/CircularProgress'

import style from '../style.css'

export default function DefaultSubmit(props) {

    const { submitRef, effect, disabled, startIcon, ContainerProps = {}, Container = 'div', color, ...rest } = props
    const [progress, setProgress] = useState(props.progress)
    const [disabledState, setDisabled] = useState(disabled || false)
    const [done, setDone] = useState(false)
    const [_color, setColor] = useState(color)

    useEffect(() => {
        if (effect) {
            effect({
                actions: {
                    setProgress,
                    setDisabled: async (value) => {
                        if (disabledState !== value) {
                            await setDisabled(value)
                        }
                    },
                    setDone,
                    setColor
                }
            })
        }
        return () => {
            if (effect) {
                effect({
                    actions: {
                        setProgress: async () => null,
                        setDisabled: async () => null,
                        setDone: async () => null,
                        setColor: async () => null
                    }
                })
            }
        }
    })

    return <Container
        {...ContainerProps}
        className={clsx(
            style.buttonContainer,
            ContainerProps.className
        )}
        name={rest.id}
    >
        <Button {...rest}
                color={_color}
                key={JSON.stringify({ disabledState, progress })}
                disabled={disabledState || progress}
                startIcon={(done) ? startIcon : (progress) ? <CircularProgress /> : startIcon}
        />
    </Container>
}
